export default __webpack_public_path__ + "static/media/050_brake.last.3abc997f.png";